import {inject, Injectable, signal} from '@angular/core';
import {CustomerBasedataConfigurationService} from '../api/generated';

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  private _customerBasedataConfigurationService = inject(CustomerBasedataConfigurationService);

  customLogo = signal<any | null>(null);
  productLogo = signal<string | null>(null);

  getCustomLogo() {
    this._customerBasedataConfigurationService.customerBasedataConfigurationGetLogo().subscribe({
      next: logo => {
        this.customLogo.set(logo?.data);
      },
      complete: () => {
        this.productLogo.set('assets/images/Roboter.png')
      }
    })
  }
}
